import { useTheme } from '@emotion/react';
import { Typography } from '@mui/material';
import React from 'react';

const SimSectionTitle = ({ title = '', children }) => {
	const theme = useTheme();
	return (
		<>
			{title && (
				<Typography
					variant='h5'
					sx={{
						[theme.breakpoints.down('md')]: { fontSize: '1.2rem' }
					}}>
					{title}
				</Typography>
			)}
			{children || ''}
		</>
	);
};

export default SimSectionTitle;
